import { UigBranchesAdapter } from './uig-branches.adapter';
import * as UigBranchesActions from './uig-branches.actions';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { BranchesList, BranchForm, StoreLocatorFeatureGroup } from '../uig-branches/uig-branches.models';

@Injectable()
export class UigBranchesEffects {

  constructor(
    private actions$: Actions,
    private uigBranchesAdapter: UigBranchesAdapter
  ) { }

  getUigBranches$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UigBranchesActions.getUigBranchesOverview),
      switchMap((action) =>
        this.uigBranchesAdapter
          .getUigBranches(
            action.params
          )
          .pipe(
            map((uigBranchesOverview: BranchesList) =>
              UigBranchesActions.getUigBranchesOverviewSuccess
                ({
                  uigBranchesOverview,
                })
            ),
            catchError((error) =>
              of(
                UigBranchesActions.getUigBranchesOverviewFailure({
                  error,
                })
              )
            )
          )
      )
    );
  });

  getUigBranchDetails$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UigBranchesActions.getUigBranchDetails),
      switchMap((action) =>
        this.uigBranchesAdapter
          .getUigBranchDetails(
            action.name
          )
          .pipe(
            map((branch: BranchForm) =>
              UigBranchesActions.getUigBranchDetailsSuccess
                ({
                  branch,
                })
            ),
            catchError((error) =>
              of(
                UigBranchesActions.getUigBranchDetailsFailure({
                  error,
                })
              )
            )
          )
      )
    );
  });

  deleteBranch$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UigBranchesActions.deleteBranch),
      switchMap((action) =>
        this.uigBranchesAdapter
          .deleteBranch(
            action.name
          )
          .pipe(
            map(() =>
              UigBranchesActions.deleteBranchSuccess()
            ),
            catchError(() =>
              of(
                UigBranchesActions.deleteBranchFailure()
              )
            )
          )
      )
    )
  });

  createOrUpdateBranch$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UigBranchesActions.createOrUpdateBranch),
      switchMap((action) =>
        this.uigBranchesAdapter
          .createOrUpdateBranch(
            action.branch
          )
          .pipe(
            map((success) => {
              if (success && success === true) {
                return UigBranchesActions.createOrUpdateBranchSuccess();
              }
              else {
                return UigBranchesActions.createOrUpdateBranchFailure();
              }
            }),
            catchError(() =>
              of(
                UigBranchesActions.createOrUpdateBranchFailure()
              )
            )
          )
      )
    )
  });

  getStoreFeatureGroups$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UigBranchesActions.getUigStoreFeatureGroups),
      switchMap(() =>
        this.uigBranchesAdapter
          .getStoreLocatorFeatureGroups(
          )
          .pipe(
            map((featureGroups: StoreLocatorFeatureGroup[]) =>
              UigBranchesActions.getUigStoreFeatureGroupsSuccess
                ({
                  featureGroups,
                })
            ),
            catchError((error) =>
              of(
                UigBranchesActions.getUigStoreFeatureGroupsFailure({
                  error,
                })
              )
            )
          )
      )
    );
  });
}